import format from 'date-fns/format'
import formatDistance from 'date-fns/formatDistance'

export default {
    install: (app) => {
        app.config.globalProperties.$dateFormatters = {
            dmy(date) {
                return format(new Date(date), 'd/MMM/yy');
            },
            distance(date) {
                return formatDistance(new Date(date), new Date(), {
                    addSuffix: true
                });
            }
        }
    }
}
